import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';

import { SurveyDesignsQueryResult, surveyDesignsQuery, surveyDesignQuery, SurveyDesignQueryResult } from './queries/surveyQuery';

type SurveyDesignsQueryParams = {
    customerId: string;
    SurveyDesignStatus?: string;
};

type SurveyDesignQueryParams = {
    projectId: string;
};
const SurveyDesignListGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        surveyDesigns: builder.query<SurveyDesignsQueryResult, SurveyDesignsQueryParams>({
            query: params => ({
                body: surveyDesignsQuery,
                variables: params,
            }),
        }),
        surveyDesign: builder.query<SurveyDesignQueryResult, SurveyDesignQueryParams>({
            query: params => ({
                body: surveyDesignQuery,
                variables: params,
            }),
            transformResponse: response => response.surveyDesign,
        }),
    }),
});

export const { useLazySurveyDesignsQuery, useSurveyDesignsQuery, useSurveyDesignQuery } = SurveyDesignListGraphSlice;

export const { surveyDesigns: fetchSurveyDesigns } = SurveyDesignListGraphSlice.endpoints;
